import { type ErrorCodeMap } from './types';

export const audioErrorCodes: ErrorCodeMap = {
  // Generic (fallback when mic/speaker context is unavailable)
  AUDIO_DEVICE_LOST: 'desktop.errors.audio.deviceLost',
  AUDIO_NO_INPUT_DEVICE: 'desktop.errors.audio.noInputDevice',
  AUDIO_NO_OUTPUT_DEVICE: 'desktop.errors.audio.noOutputDevice',
  AUDIO_PERMISSION_DENIED: 'desktop.errors.audio.permissionDenied',
  AUDIO_DEVICE_ERROR: 'desktop.errors.audio.deviceError',
  AUDIO_STREAM_ERROR: 'desktop.errors.audio.streamError',
  AUDIO_CONFIG_ERROR: 'desktop.errors.audio.configError',
  AUDIO_STREAM_CREATE_FAILED: 'desktop.errors.audio.streamCreateFailed',
  AUDIO_STREAM_PLAY_FAILED: 'desktop.errors.audio.streamPlayFailed',
  AUDIO_STREAM_PAUSE_FAILED: 'desktop.errors.audio.streamPauseFailed',
  AUDIO_SCK_ERROR: 'desktop.errors.audio.sckError',
  // Microphone
  AUDIO_MIC_EMPTY: 'desktop.errors.audio.micEmpty',
  AUDIO_MIC_STREAM_ERROR: 'desktop.errors.audio.micStreamError',
  AUDIO_MIC_FORMAT_UNSUPPORTED: 'desktop.errors.audio.micFormatUnsupported',
  AUDIO_MIC_STREAM_CREATE_FAILED: 'desktop.errors.audio.micStreamCreateFailed',
  AUDIO_MIC_RECORD_FAILED: 'desktop.errors.audio.micRecordFailed',
  AUDIO_MIC_START_FAILED: 'desktop.errors.audio.micStartFailed',
  // Speaker
  AUDIO_SPEAKER_EMPTY: 'desktop.errors.audio.speakerEmpty',
  AUDIO_SPEAKER_STREAM_ERROR: 'desktop.errors.audio.speakerStreamError',
  AUDIO_SPEAKER_FORMAT_UNSUPPORTED: 'desktop.errors.audio.speakerFormatUnsupported',
  AUDIO_SPEAKER_STREAM_CREATE_FAILED: 'desktop.errors.audio.speakerStreamCreateFailed',
  AUDIO_SPEAKER_SILENCE_FAILED: 'desktop.errors.audio.speakerSilenceFailed',
  AUDIO_SPEAKER_RECORD_FAILED: 'desktop.errors.audio.speakerRecordFailed',
  AUDIO_SPEAKER_START_FAILED: 'desktop.errors.audio.speakerStartFailed',
  AUDIO_SPEAKER_SCK_RECORD_FAILED: 'desktop.errors.audio.speakerSckRecordFailed',
  AUDIO_SPEAKER_SCK_START_FAILED: 'desktop.errors.audio.speakerSckStartFailed',
  // BlackHole
  AUDIO_BLACKHOLE_CONFIG: 'desktop.errors.audio.blackholeConfig',
};
